import styles from './styles'

const getStyles = ({ overrideStyles, flash, deleteEnter, focused, pinned }) => {
  let tagStyle = { ...styles.tag }

  if (overrideStyles && overrideStyles.tags) {
    const { tag = {}, cross = {} } = overrideStyles.tags
    tagStyle = { ...tagStyle, ...tag }
  }

  if (deleteEnter || focused) {
    tagStyle = { ...tagStyle, ...styles.deleteEnter }
    if (overrideStyles && overrideStyles.tags) {
      const { deleteEnter = {} } = overrideStyles.tags
      tagStyle = { ...tagStyle, ...deleteEnter }
    }
    if (pinned) {
      tagStyle = { ...tagStyle, ...styles.pinnedEnter }
      if (overrideStyles && overrideStyles.tags) {
        const { pinnedEnter = {} } = overrideStyles.tags
        tagStyle = { ...tagStyle, ...pinnedEnter }
      }
    }
  }
  if (pinned) {
    tagStyle = { ...tagStyle, ...styles.pinnedTag }
    if (overrideStyles && overrideStyles.tags) {
      const { pinnedTag = {} } = overrideStyles.tags
      tagStyle = { ...tagStyle, ...pinnedTag }
    }
  }
  if (flash) {
    tagStyle = { ...tagStyle, ...styles.flash }
    if (overrideStyles && overrideStyles.tags) {
      const { flash = {} } = overrideStyles.tags
      tagStyle = { ...tagStyle, ...flash }
    }
  }
  return tagStyle
}

export default getStyles
